var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3840,
    height: 2160,
    viewBox: "0 0 3840 2160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_819_2162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2580.06 1149.95C2581.31 1147.14 2582 1144.04 2582 1140.78C2582 1128.2 2571.7 1118 2559 1118C2546.3 1118 2536 1128.2 2536 1140.78C2536 1143.44 2536.46 1145.99 2537.31 1148.37L2537.28 1148.37C2537.37 1148.58 2537.46 1148.79 2537.55 1149C2537.81 1149.67 2538.1 1150.32 2538.42 1150.95C2543.12 1161.05 2551.06 1172.13 2559 1180C2567.63 1171.46 2576.76 1157.79 2580.08 1149.95L2580.06 1149.95Z",
    fill: "#3C373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580.06 1149.95L2579.14 1149.54L2578.54 1150.89L2580.02 1150.95L2580.06 1149.95ZM2537.31 1148.37L2537.27 1149.37L2538.75 1149.42L2538.25 1148.03L2537.31 1148.37ZM2537.28 1148.37L2537.32 1147.37L2535.76 1147.31L2536.35 1148.75L2537.28 1148.37ZM2537.55 1149L2538.48 1148.64L2538.47 1148.62L2538.47 1148.61L2537.55 1149ZM2538.42 1150.95L2539.32 1150.53L2539.32 1150.51L2539.31 1150.5L2538.42 1150.95ZM2559 1180L2558.3 1180.71L2559 1181.41L2559.7 1180.71L2559 1180ZM2580.08 1149.95L2581 1150.34L2581.57 1149L2580.12 1148.95L2580.08 1149.95ZM2581 1140.78C2581 1143.9 2580.34 1146.86 2579.14 1149.54L2580.97 1150.35C2582.28 1147.42 2583 1144.18 2583 1140.78H2581ZM2559 1119C2571.16 1119 2581 1128.76 2581 1140.78H2583C2583 1127.64 2572.25 1117 2559 1117V1119ZM2537 1140.78C2537 1128.76 2546.84 1119 2559 1119V1117C2545.75 1117 2535 1127.64 2535 1140.78H2537ZM2538.25 1148.03C2537.44 1145.76 2537 1143.32 2537 1140.78H2535C2535 1143.55 2535.48 1146.22 2536.37 1148.71L2538.25 1148.03ZM2537.24 1149.37L2537.27 1149.37L2537.35 1147.37L2537.32 1147.37L2537.24 1149.37ZM2538.47 1148.61C2538.38 1148.4 2538.29 1148.19 2538.2 1147.98L2536.35 1148.75C2536.44 1148.97 2536.54 1149.18 2536.63 1149.4L2538.47 1148.61ZM2539.31 1150.5C2539 1149.89 2538.73 1149.27 2538.48 1148.64L2536.62 1149.37C2536.89 1150.06 2537.19 1150.74 2537.52 1151.4L2539.31 1150.5ZM2559.7 1179.29C2551.84 1171.5 2543.97 1160.52 2539.32 1150.53L2537.51 1151.37C2542.26 1161.59 2550.27 1172.77 2558.3 1180.71L2559.7 1179.29ZM2579.16 1149.56C2575.9 1157.27 2566.84 1170.83 2558.3 1179.29L2559.7 1180.71C2568.41 1172.09 2577.63 1158.32 2581 1150.34L2579.16 1149.56ZM2580.02 1150.95L2580.05 1150.95L2580.12 1148.95L2580.1 1148.95L2580.02 1150.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2559 1152.1C2566.26 1152.1 2572.14 1146.28 2572.14 1139.11C2572.14 1131.94 2566.26 1126.12 2559 1126.12C2551.74 1126.12 2545.86 1131.94 2545.86 1139.11C2545.86 1146.28 2551.74 1152.1 2559 1152.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_819_2162",
    x: 2532,
    y: 1117,
    width: 54,
    height: 70.4076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_819_2162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_819_2162",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/PIN.18e256cb302d1f8c751fe0c6d04469bd.svg";
export { ForwardRef as ReactComponent };